export default __webpack_public_path__ + "static/media/system-b-logo.2bfa28e5.svg";